import { webApi } from "../../../../core/http/httpThunks";
import { ProductGroupData } from "../types";

export const getAllProductGroupsApi = (userId: string) =>
	webApi<ProductGroupData[]>({
		method: "GET",
		url: "listing/getprodgrouplist",
		params: {
			userId,
		},
	});

export default getAllProductGroupsApi;
